export interface GlobalShortcut {
  id: string;
  description: string;
  keys: string;
  browserKeys: string;
}

export const SHORTCUTS: GlobalShortcut[] = [
  {
    id: 'createChannel',
    description: 'Create a new channel',
    keys: 'CmdOrCtrl+Shift+N',
    browserKeys: 'CmdOrCtrl+Shift+Alt+N',
  },
  {
    id: 'createMessage',
    description: 'Create a new direct message',
    keys: 'CmdOrCtrl+N',
    browserKeys: 'CmdOrCtrl+Alt+N',
  },
  {
    id: 'allOrganizations',
    description: 'View all organizations',
    keys: 'CmdOrCtrl+O',
    browserKeys: 'CmdOrCtrl+Alt+O',
  },
  {
    id: 'find',
    description: 'Search for messages or files',
    keys: 'CmdOrCtrl+F',
    browserKeys: 'CmdOrCtrl+Alt+F',
  },
  {
    id: 'goTo',
    description: 'Go to a specific channel or message',
    keys: 'CmdOrCtrl+G',
    browserKeys: 'CmdOrCtrl+Alt+G',
  },
  {
    id: 'documentation',
    description: 'Open documentation',
    keys: 'CmdOrCtrl+H',
    browserKeys: 'CmdOrCtrl+Alt+H',
  },
  {
    id: 'todos',
    description: 'Toggle the To Dos sidebar',
    keys: 'CmdOrCtrl+T',
    browserKeys: 'CmdOrCtrl+Alt+T',
  },
];
